/* Deal Price 优惠明细弹窗：事件委托，兼容变体切换后 DOM 重建 */
(function () {
  if (window.__productDealModalBound) return;
  window.__productDealModalBound = true;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-deal-open]');
    if (opener) {
      e.preventDefault();
      var scope = opener.closest('.product-price-container') || document;
      var modal = scope.querySelector('[data-deal-modal]');
      if (modal) modal.hidden = false;
      return;
    }
    if (e.target.closest('[data-deal-close]')) {
      var m = e.target.closest('[data-deal-modal]');
      if (m) m.hidden = true;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-deal-modal]:not([hidden])').forEach(function (m) {
        m.hidden = true;
      });
    }
  });
})();
